import styled from "styled-components";

const Container = styled.div`
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #bbde87;
`;

interface Props {
  children: React.ReactNode;
}

const FooterContainer = ({ children }: Props) => {
  return <Container>{children}</Container>;
};

export default FooterContainer;
